import { createFileRoute } from '@tanstack/react-router'
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { SensorKitValidateSensorPlacementsCard } from "@/sync/SensorKitValidateSensorPlacementsCard";

export const Route = createFileRoute(
  '/_authenticated/_staff/validate-sensor-placement',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const [serialNumber, setSerialNumber] = useState("")
  const [submittedSerialNumber, setSubmittedSerialNumber] = useState<string>()

  const handleSubmit = () => {
    if (serialNumber.trim()) {
      setSubmittedSerialNumber(serialNumber.trim())
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <Input
          placeholder="Sensor kit serial number (internal or external)"
          value={serialNumber}
          onChange={e => setSerialNumber(e.target.value)}
        />
        <Button onClick={handleSubmit} disabled={!serialNumber.trim()}>
          Submit
        </Button>
      </div>
      {
        submittedSerialNumber && (
          <SensorKitValidateSensorPlacementsCard sensorKitSerialNumber={submittedSerialNumber}/>
        )
      }
    </div>
  )
}